import React, { forwardRef, useImperativeHandle } from "react";
import { jsPDF } from "jspdf";
import "jspdf-autotable";

const DownloadPdf = forwardRef(
  (
    {
      headers,
      data,
      fileName,
      title,
      companyName,
      logo,
      setOpenBackdrop,
      showTotalAmount,
      totalAmount,
      customerName,
      customerAddress,
      summaryData,
    },
    ref
  ) => {
    const generatePdf = () => {
      if (!data || data.length === 0) {
        return;
      }

      const doc = new jsPDF();

      if (setOpenBackdrop) setOpenBackdrop(true);

      doc.setFontSize(18);
      doc.text(companyName,105, 10, { align: "center" } ); // Adjusted position
      

      if (logo) {
        doc.addImage(logo, "PNG", 5, 5, 10, 10); // Adjust width and height as per your logo size
      }

      doc.setFontSize(12);
      doc.text(title, 105, 17, { align: "center" });

      doc.setFontSize(12);
      doc.text(`Customer: ${customerName}`, 105, 25, { align: "center" }); // ✅ Added Customer Name
      doc.setFontSize(11);
      doc.text(`Address: ${customerAddress}`, 105, 30, { align: "center" }); // ✅ Added Customer Name

      doc.autoTable({
        startY: 33,
        head: [headers],
        body: data,
      });

      // Add Total Amount if applicable
      // Add summary line with colored dues
      if (summaryData) {
        const finalY = doc.autoTable.previous.finalY + 10;
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0); // Black
      
        const { invoice = 0, payment = 0, receipt = 0, dues = 0 } = summaryData;
      
        // First line: Invoice and Payment
        doc.text(`Invoice: Rs. ${invoice}`, 14, finalY);
        doc.text(`Payment: Rs. ${payment}`, 105, finalY, { align: "center" });
      
        // Second line: Receipt and Dues
        const nextLineY = finalY + 8;
        doc.text(`Receipt: Rs. ${receipt}`, 14, nextLineY);
      
        doc.setTextColor(255, 0, 0); // Red for Dues
        doc.text(`Dues: Rs. ${dues}`, 105, nextLineY, { align: "center" });
      
        doc.setTextColor(0, 0, 0); // Reset
      }
      

      const date = new Date().toLocaleDateString();
      doc.save(`${fileName}_${date}.pdf`);

      if (setOpenBackdrop) setOpenBackdrop(false);
    };

    useImperativeHandle(ref, () => ({
      generatePdf,
    }));

    return null;
  }
);

export default DownloadPdf;
